var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.$route.meta.headerTop)?_c('HeaderTop'):_vm._e(),(_vm.$route.meta.personal !== true)?_c('router-view'):_vm._e(),_c('div',{staticClass:"content-box"},[(_vm.$route.meta.personal)?_c('CatalogueLeft'):_vm._e(),(_vm.$route.meta.personal)?_c('Content'):_vm._e()],1),(!_vm.$route.meta.footer)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }